// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".svgIconComponent---qOa8m{display:block;pointer-events:none;width:12px;background:transparent !important}.svgIconComponent---qOa8m>span{background:transparent}.svgIconComponent---qOa8m>span>svg{background:transparent}.dueDateInfoIcon---1OcNj{display:block;pointer-events:none;width:17px;height:17px;background:transparent !important}.dueDateInfoIcon---1OcNj>span{background:transparent}.dueDateInfoIcon---1OcNj>span>svg{background:transparent}\n", ""]);
// Exports
exports.locals = {
	"svgIconComponent": "svgIconComponent---qOa8m",
	"dueDateInfoIcon": "dueDateInfoIcon---1OcNj"
};
module.exports = exports;
